<template>
  <div class="modal">
    <div class="complete">
      <div class="box">
        <div class="title">{{ badge.title }}</div>
        <div class="subtitle">
          {{ badge.subtitle }}
        </div>
        <div class="success-badge">
          <BadgeBig :badge="badge" />
        </div>
        <div class="subtext text-align-center">
          {{ badge.subtext }}
        </div>
        <div class="confirm noselect text-align-center" @click="confirmBadge">
          {{ badge.action }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BadgeBig from "./BadgeBig";

import { BadgeStore } from "../../ELYX/ELYXStore";
import BadgeMethods from "../../ELYX/Badges/BadgeMethods";

export default {
  name: "BadgeAwardModal",
  computed: {
    unawardedBadges: () => BadgeStore.state.unawardedBadges,

    ...mapState({
      user: (state) => state.auth.user,
    }),

    /** return first badge from unawarded badges in one line*/
    badge() {
      return this.unawardedBadges[0];
    },
  },
  components: {
    BadgeBig,
  },
  methods: {
    async confirmBadge() {
      await BadgeMethods.confirmGotBadge(this.badge.badgeNr);
      this.closeModal();
      await BadgeMethods.getUserUnawardedBadges();
    },

    closeModal: BadgeMethods.clearUnawardedBadges,
  },
};
</script>

<style scoped>
.modal {
  position: absolute;
  z-index: 9999999999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  overflow: auto;
}

.complete {
  width: 765px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.complete .box {
  width: 590px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 65px 20px;
  background-color: white;
  margin-bottom: 65px;
  margin-top: 25px;
  padding-bottom: 60px;
  border-radius: 25px;
  box-shadow: 0px 2px 2px 2px #5d5d5d45;
  border: 1px solid #eee;

  /** EXPERIMENTAL */
  transform: scale(0.9);
}

.complete .box .title {
  font-size: 45px;
}

.complete .box .subtitle {
  font-size: 24px;
  width: 75%;
  white-space: normal;
  font-weight: 400;
  padding: 15px 0px 0px 0px;
  text-align: center;
  margin: 0px auto;
  margin-top: 5px;
  line-height: 34px;
}

.complete .box .subtext {
  white-space: normal;
  width: 75%;
  padding: 5px 0px;
  line-height: 27px;
  font-size: 20px;
  box-sizing: border-box;
  font-weight: 600;
  text-align: center;
  color: #2d2d2d;
}

.complete .box .confirm {
  font-size: 35px;
  outline: none;
  background-color: #0c0c0c;
  color: #ffffff;
  font-weight: 700;
  border: unset;
  padding: 12px 10px;
  width: 100%;
  cursor: pointer;
  display: block;
  margin: 0 auto;
  margin-top: 14px;
  max-width: 275px;
  transition: 0.1s ease-in-out;
  text-align: center;
  border-radius: 360px;
}

.text-align-center {
  text-align: center;
}

.complete .box .confirm:hover {
  background-color: #49494c;
}

.complete .box .success-badge {
  height: 300px;
  width: 300px;
  padding: 20px 0px;
  padding-bottom: 0px;
  margin-bottom: 25px;
}
</style>
